import { Component, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import { ICellEditorParams } from 'ag-grid-community';

@Component({
  selector: 'lum-cost-layer-unit-cost-cell-editor',
  templateUrl: './cost-layer-unit-cost-cell-editor.component.html',
  styleUrls: ['./cost-layer-unit-cost-cell-editor.component.scss'],
})
export class CostLayerUnitCostCellEditorComponent
  implements ICellEditorAngularComp, AfterViewInit
{
  private params :ICellEditorParams;
  public value :string;

  @ViewChild('inputRef', { static: true }) inputRef :ElementRef;

  agInit(params :ICellEditorParams) :void {
    this.params = params;
    this.value = params.value;
  }

  ngAfterViewInit() :void {
    setTimeout(() => this.inputRef.nativeElement.focus(), 0);
  }

  getValue() :string {
    return this.value;
  }

  isCancelBeforeStart() :boolean {
    return false;
  }

  onKeyDown(event :KeyboardEvent) :void {
    if (event.key === 'Enter') {
      this.params.stopEditing();
    }
  }
}
